<template lang="html">
  <div class="_infoheader">
    <div class="row __wrapper_" v-if="header && header.bookData">
      <div class="_infoheader_back" @click="goBack">
          <img src="@/assets/image/icon/left-arrow-blue.svg" alt="">
          <span>Back</span>
      </div>
      <div class="col-md-3 p-0 _infoheader__left">
        <div class="row _infoheader__leftCol--texttop">
          <img class="__img" src = "@/assets/image/icon/plane.svg">
          <span class="__text">{{ header.bookData.orderOriginCity }} - {{ header.bookData.orderDestinationCity }}</span>
        </div>
        <p class="_infoheader__leftCol--textmiddle"><span class="__ft">{{ getFreigtMode(header.inputData.form.service_head) }}</span>
        | {{  header.inputData.form.service_head === 'AIR' ? getShipmentType(header.inputData.form.shipment_type) : header.inputData.form.shipment_type.replace(/SEA/g,'') }} <span class="__type"></span></p>
        <p class="_infoheader__leftCol--textwhite">Booking Forms</p>
      </div>
      <div class="col-md _infoheader__middle">
        <div class="row">
          <div class="col-md-5 pr-0">Freight Mode</div>
          <div class="col-md">: {{ getFreigtMode(header.inputData.form.service_head) }}</div>
        </div>
        <div class="row">
          <div class="col-md-5 pr-0">Shipment Type</div>
          <div class="col-md">: {{  getShipmentType(header.inputData.form.shipment_type.replace(/SEA/g,'')) }}</div>
        </div>
        <!-- FCL -->
        <div class="row" v-if="header.inputData.shipmentLoad === 'fcl'">
          <div class="col-md-5 pr-0">Container Size</div>
          <div class="col-md">: {{ header.inputData.form.shipment_type === 'SEAFCL20FT' ? '20FT' : header.inputData.form.shipment_type === 'SEAFCL40FT' ? '40FT' : header.inputData.form.shipment_type === 'SEAFCL40FTHC' && '40FTHC'}}</div>
        </div>
        <div class="row" v-if="header.inputData.shipmentLoad === 'fcl'">
          <div class="col-md-5 pr-0">Container Type</div>
          <div class="col-md">: {{ header.inputData.form.loadsFCL ? header.inputData.form.loadsFCL[0].type : '-' }}</div>
        </div>
        <div class="row" v-if="subType === 'reefer'">
          <div class="col-md-5 pr-0">Temperature</div>
          <div class="col-md">: {{ header.inputData.form.temperature || '' }}</div>
        </div>
        <div class="row" v-if="header.inputData.shipmentLoad === 'fcl' && header.inputData.shipmentLoad.container_option">
          <div class="col-md-5 pr-0">Container Option</div>
          <div class="col-md">: {{ getContainerOption(header.inputData.form.container_option) }} </div>
        </div>
        <div class="row" v-if="header.inputData.shipmentLoad === 'fcl'">
          <div class="col-md-5 pr-0">Quantity</div>
          <div class="col-md">: {{ header.inputData.form.totalUnit || '' }} Container</div>
        </div>
        <div class="row" v-if="header.inputData.shipmentLoad === 'fcl' && header.inputData.form.weight_estimation">
          <div class="col-md-5 pr-0">Weight Estimation</div>
          <div class="col-md">: {{ header.inputData.form.weight_estimation }} Kg</div>
        </div>
        <!-- END FCL -->
        <!-- AIR / LCL -->
        <div class="row" v-if="header.inputData.shipmentLoad === 'lcl'">
          <div class="col-md-5 pr-0">Quantity</div>
          <div class="col-md">: {{ header.inputData.form.totalUnit || '' }} {{ header.inputData.form.loadsLCL[0].type}}</div>
        </div>
        <div class="row" v-if="header.inputData.shipmentLoad === 'aircargo'">
          <div class="col-md-5 pr-0">Quantity</div>
          <div class="col-md">: {{ header.inputData.form.totalUnit || '' }} {{ header.inputData.form.loadsAIRCargo[0].type}}</div>
        </div>
        <div class="row" v-if="header.inputData.shipmentLoad === 'aircourier'">
          <div class="col-md-5 pr-0">Quantity</div>
          <div class="col-md">: {{ header.inputData.form.totalUnit || '' }} {{ header.inputData.form.loadsAIRCourier[0].type}}</div>
        </div>
        <div class="row" v-if="header.inputData.shipmentLoad === 'lcl' || header.inputData.shipmentLoad === 'aircargo' || header.inputData.shipmentLoad === 'aircourier'">
          <div class="col-md-5 pr-0">Weight</div>
          <div class="col-md">: {{ parseFloat(header.inputData.form.totalWeight).toFixed(1) || '' }} kg</div>
        </div>
        <div class="row" v-if="header.inputData.shipmentLoad === 'aircargo' || header.inputData.shipmentLoad === 'aircourier'">
          <div class="col-md-5 pr-0">Volume</div>
          <div class="col-md">: {{ header.inputData.form.totalVolumetric || '' }} Volumetric</div>
        </div>
        <div class="row" v-if="header.inputData.shipmentLoad === 'lcl'">
          <div class="col-md-5 pr-0">Volume</div>
          <div class="col-md">: {{ header.inputData.form.totalVolumetric || '' }} cbm</div>
        </div>
        <!-- END AIR / LCL -->
        <div class="row">
          <div class="col-md-5 pr-0">Product Type</div>
          <div class="col-md">: {{ getProductType(header.inputData.form.commoditiesClass) }}</div>
        </div>
        <div class="row">
          <div class="col-md-5 pr-0">Kind of Goods</div>
          <div class="col-md">: {{ header.inputData.form.productType || '' }}</div>
        </div>
        <div class="row" v-if="header.inputData.form.commoditiesClass === 'DG' &&  header.inputData.form.un_number ">
          <div class="col-md-5 pr-0">UN Number</div>
          <div class="col-md">: {{ header.inputData.form.un_number }}</div>
        </div>
        <div class="row">
          <div class="col-md-5 pr-0">Value of Goods</div>
          <div class="col-md">: {{ header.inputData.form.goodsValue | currency('IDR', 0, { spaceBetweenAmountAndSymbol: true}) }}</div>
        </div>
      </div>
      <div class="col-md _infoheader__right">
        <div class="row">
          <div class="col-md-5 pr-0">HS Code</div>
          <div class="col-md">: {{ header.inputData.form.commoditiesHSCode || '' }}</div>
        </div>
        <div class="row">
          <div class="col-md-5 pr-0">Product Description</div>
          <div class="col-md">: {{ header.inputData.form.commoditiesProduct || '' }}</div>
        </div>
        <div class="row">
          <div class="col-md-5 pr-0">Shipment Service</div>
          <div class="col-md">: {{ getOptionTp(header.inputData.form.optiontp) || '' }}</div>
        </div>
        <div class="row">
          <div class="col-md-5 pr-0">Origin Country</div>
          <div class="col-md">: {{ header.bookData.orderOriginCountry || '' }}</div>
        </div>
        <div class="row">
          <div class="col-md-5 pr-0">Origin City</div>
          <div class="col-md">: {{ header.bookData.orderOriginCity || '' }}</div>
        </div>
        <div class="row" v-if="(header.inputData.form.optiontp ==='dtp' || header.inputData.form.optiontp === 'dtd')">
          <div class="col-md-5 pr-0">Pickup Address</div>
          <div class="col-md">: {{ header.inputData.form.pickup_address || '' }}</div>
        </div>
        <div class="row">
          <div class="col-md-5 pr-0">Destination Country</div>
          <div class="col-md">: {{ header.bookData.orderDestinationCountry || '' }}</div>
        </div>
        <div class="row">
          <div class="col-md-5 pr-0">Destination City</div>
          <div class="col-md">: {{ header.bookData.orderDestinationCity || '' }}</div>
        </div>
        <div class="row" v-if="(header.inputData.form.optiontp ==='ptd' || header.inputData.form.optiontp === 'dtd')">
          <div class="col-md-5 pr-0">Delivery Address</div>
          <div class="col-md">: {{ header.inputData.form.delivery_address || '' }}</div>
        </div>
        <div class="row">
          <div class="col-md-5 pr-0">Shipment Date</div>
          <div class="col-md">: {{ header.inputData.form.datePickup || '' }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoHeader',
  data () {
    return {
    }
  },
  props: {
    header: Object
  },
  computed: {
    subType () {
      let sub = this.header.inputData.form.loadsFCL ? this.header.inputData.form.loadsFCL[0].type : ''
      return sub
    }
  },
  methods: {
    goBack () {
      window.history.length > 1
        ? this.$router.go(-1)
        : this.$router.push('/')
    },
    getContainerOption (data) {
      if (data === 'SOC') { return `Shipper's Own Container (SOC)` } else if (data === 'COC') { return `Carrier's Owned Container (COC)` } else { return '-' }
    },
    getProductType (type) {
      if (type === 'GENCO') { return 'General Cargo' }
      if (type === 'SC') { return 'Special Cargo' }
      if (type === 'DG') { return 'Dangerous Goods' }
    },
    getFreigtMode (mode) {
      if (mode === 'OCEAN') { return 'Ocean' }
      if (mode === 'AIR') { return 'Air' }
    },
    getShipmentType (type) {
      if (type === 'AIRCARGO') {
        const newType = type.replace('AIRCARGO', 'Air Cargo')
        return newType
      } else if (type === 'AIRCOURIER') {
        const newType = type.replace('AIRCOURIER', 'Air Courier')
        return newType
      } else {
        if (type !== 'LCL') { return 'FCL' } else { return 'LCL' }
      }
    },
    getOptionTp (type) {
      let optionTp = '-'
      switch (type) {
        case 'ptp' : optionTp = 'Port to Port'
          break
        case 'dtp' : optionTp = 'Door to Port'
          break
        case 'dtd' : optionTp = 'Door to Door'
          break
        case 'ptd' : optionTp = 'Port to Door'
          break
        default : optionTp = '-'
        /* eslint-disable-next-line */
      } 
      /* eslint-disable-next-line */
      return optionTp
      /* eslint-disable-next-line */
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/instantPrice/InfoHeader.vue